// @flow
import type { State } from 'store/State';
import { createSelector } from 'reselect';

type statesObject = {
  code: string,
  name: string
};

export const statesSelector = (state: State): statesObject => state.states;

export const getStates = createSelector(statesSelector, states => {
  return states.map(state => {
    return { value: state.code, label: state.name };
  });
});



// WEBPACK FOOTER //
// ./src/store/reducers/states/selectors.js